import { BasePessoaModel } from "../base/base-pessoa-model";

export class TenantLicencaModel extends BasePessoaModel {
    public dataExpiracao: Date;
    public diasCarencia: number;
    public nomePlano: string;    
}